exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".renderer-container {\r\n    font-size: 13px;\r\n}\r\n.input-group.renderer-group {\r\n    width: 100% !important;\r\n}\r\n.input-group-append.renderer-addon img {\r\n    margin-top: -22px;\r\n}\r\n.form-control.renderer-input {\r\n    margin-top: 3px;\r\n    border-radius: 0px;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    color: #12408B;\r\n    font-weight: 600;\r\n    border: none;\r\n    height: 20px;\r\n    box-shadow: none;\r\n    width: calc(100% - 28px);\r\n    cursor: pointer;\r\n    background-color: transparent;\r\n}\r\n.form-control.renderer-input:hover {\r\n    color: #CD202C;\r\n}\r\n.input-group-text.renderer-addon img {\r\n    margin: 3px 6px 0px 0px;\r\n    pointer-events: all;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/search-criteria-popup/search-criteria-cell-renderer/search-criteria-cell-renderer.component.css
// module id = ../../../../../src/app/shared/lookup/search-criteria-popup/search-criteria-cell-renderer/search-criteria-cell-renderer.component.css
// module chunks = main